import { render, staticRenderFns } from "./MembersBenefits.vue?vue&type=template&id=4337bcc2&scoped=true"
import script from "./MembersBenefits.vue?vue&type=script&lang=js"
export * from "./MembersBenefits.vue?vue&type=script&lang=js"
import style0 from "./MembersBenefits.vue?vue&type=style&index=0&id=4337bcc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4337bcc2",
  null
  
)

export default component.exports